const common = {
  Loading: "लोड हो रहा है",
  signUp: "साइन अप करें",
  login: "लॉग इन करें",
  logout: "लॉग आउट करें",
  email: "ईमेल",
  emailFormatErrorTips: "ईमेल फॉर्मेट गलत है",
  emailDifferentTips: "कृपया दोनों क्षेत्रों में एक ही ईमेल डालें।",
  emailRegisteredTips: "यह ईमेल पंजीकृत किया गया है, कृपया कोई दूसरा चुनें।",
  password: "पासवर्ड",
  passwordFormatErrorTips: "पासवर्ड 8-50 अक्षर का होना चाहिए और इसमें निम्न में से कम से कम दो श्रेणियां होनी चाहिए: संख्या, अक्षर या विशेष वर्ण।",
  passwordDifferentTips: "कृपया दोनों क्षेत्रों में एक ही पासवर्ड डालें।",
  verificationCode: "सत्यापन कोड",
  verificationCodeErrorTips: "गलत सत्यापन कोड",
  confirm: "पुष्टि करें",
  cancel: "रद्द करें",
  submit: "जमा करें",
  confirmEmail: "ईमेल की पुष्टि करें",
  formEmptyErrorTips: "यहाँ खाली नहीं हो सकता।",
  country: "देश/क्षेत्र",
  birthday: "जन्मदिन",
  anonymous: "अनाम",
  name: "नाम",
  nameFormatErrorTips: "प्रयोगकर्ता नाम 50 अक्षर के अंदर होना चाहिए और इसमें विशेष वर्ण नहीं होने चाहिए",
  okBtn: "ठीक है",
  serverErrorTips: "माफ़ करें, कुछ गड़बड़ हो गयी थी, कृपया बाद में दोबारा कोशिश करें।",
  updateSuccessTips: "सफलतापूर्वक संशोधित",
  authorizationExpiredErrorTips: "प्रमाणीकरण समाप्त हो गया है, कृपया दोबारा लॉगइन करें।",
  requestFrequentlyErrorTips: "बहुत कम समय में बहुत सारे समान अनुरोध किये गए थे, कृपया बाद में दोबारा कोशिश करें।",
  GetCode:'कोड प्राप्त करें'
};

export default common;
